import { render, staticRenderFns } from "./SearchRecipeCategoriesMobile.vue?vue&type=template&id=e56ebb14&"
import script from "./SearchRecipeCategoriesMobile.vue?vue&type=script&lang=js&"
export * from "./SearchRecipeCategoriesMobile.vue?vue&type=script&lang=js&"
import style0 from "./SearchRecipeCategoriesMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports